// extracted by mini-css-extract-plugin
export default {"FormSelector":"FormSelector_FormSelector__gScIP"};